import { forwardRef, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';

import useTranslation from '@hooks/useTranslation';

import { debounce } from '@helpers/debounce';

import { ReactComponent as ScrollTopIcon } from '@assets/svg/scroll-top.svg';

import style from './style.module.scss'

const ButtonGoUp = forwardRef((_, ref) => {
  const [showUpBtn, setShowUpBtn] = useState(false);
  const { t } = useTranslation();

  const onScrollTable = debounce((event) => {
    if (event?.target?.scrollTop > 200 && !showUpBtn) {
      setShowUpBtn(true);
    } else if (event?.target?.scrollTop < 200 && showUpBtn) {
      setShowUpBtn(false);
    }
  }, 250);

  useEffect(() => {
    const tableRef = ref?.current;

    tableRef?.addEventListener('scroll', onScrollTable, {
      passive: true,
    });
    return () => {
      tableRef?.removeEventListener('scroll', onScrollTable, {
        passive: true,
      });
    };
  }, [onScrollTable]);

  if (!showUpBtn) {
    return null;
  }
  return (
    <>
      <ScrollTopIcon
        id="to-top-btn"
        className={style.scrollTopIcon}
        onClick={() => ref.current.scroll({ top: 0, behavior: 'smooth' })}
      />
      <Tooltip anchorSelect="#to-top-btn" content={t('Go Up')} />
    </>
  )
});

export default ButtonGoUp;
